import { render, staticRenderFns } from "./VueSimpleEmbed.vue?vue&type=template&id=615ea92a&scoped=true&"
import script from "./VueSimpleEmbed.vue?vue&type=script&lang=js&"
export * from "./VueSimpleEmbed.vue?vue&type=script&lang=js&"
import style0 from "./VueSimpleEmbed.vue?vue&type=style&index=0&id=615ea92a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ea92a",
  null
  
)

export default component.exports